import type { ReactNode } from 'react';
import './cabinet-heading.css';

export interface CabinetHeadingProps {
  action?: ReactNode;
  className?: string;
  figmaNode?: string;
  subtitle?: ReactNode;
  title: ReactNode;
}

export function CabinetHeading({
  action,
  className = '',
  figmaNode,
  subtitle,
  title,
}: CabinetHeadingProps) {
  return (
    <header className={`cabinet-page-heading ${className}`.trim()} data-figma-node={figmaNode}>
      <div className="cabinet-page-heading__content">
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {action}
    </header>
  );
}
